import React, { Fragment } from 'react';
import { ProductItemV2 } from '../../../types/product';
import Img from '../../Img/Img';
import likeBtn from '../../../static/images/common/like-btn.png';
import { makeNumberWithComma } from '../../../lib/utils/numberUtils';
import { PreviewProductCardStyle } from './style';

interface PreviewProductCardProps {
  className?: string;
  product: ProductItemV2;
}

const PreviewProductCard = (props: PreviewProductCardProps) => {
  const { className, product } = props;
  const { imageUrl, brandName, name, discountRate, salesPrice } = product;

  return (
    <PreviewProductCardStyle className={className}>
      <Img clickAble={false} src={imageUrl} />

      <div className="product-info">
        <div className="brand-name-and-like-btn-area">
          <div className="brand-name">{brandName}</div>

          <Img className="like-btn" clickAble={false} src={likeBtn} />
        </div>

        <div className="product-name">{name}</div>

        <div className="product-price-info">
          <span className="discount-price">
            {discountRate ? (
              <Fragment>
                {makeNumberWithComma(discountRate)}
                <span className="unit">%</span>
              </Fragment>
            ) : null}
          </span>
          <span className="sales-price">
            {makeNumberWithComma(salesPrice)}
            <span className="unit">원</span>
          </span>
        </div>
      </div>
    </PreviewProductCardStyle>
  );
};

export default PreviewProductCard;
